import axios from 'axios';

let onSessionExpiredCallback = null;
let sessionInterval;

export function setOnSessionExpired(callback) {
  onSessionExpiredCallback = callback;
}

export async function checkSession() {
  try {
    await axios.get('/api/auth/keep-alive', { withCredentials: true });
  } catch (error) {
    stopSessionInterval();
    if (onSessionExpiredCallback) {
      onSessionExpiredCallback();
    }
  }
}

export function startSessionInterval() {
  if (sessionInterval) clearInterval(sessionInterval);
  sessionInterval = window.setInterval(checkSession, 1 * 60 * 1000); // 1 мин
}

export function stopSessionInterval() {
  if (sessionInterval) {
    clearInterval(sessionInterval);
    sessionInterval = undefined;
  }
}
